<template>
  <v-fade-transition mode="out-in">
    <v-icon>
      {{ icons.mdiBellRingOutline }}
    </v-icon>
  </v-fade-transition>
</template>

<script>
import { mdiBellRingOutline } from '@mdi/js'

export default {
  setup() {
    return {

      icons: {
        mdiBellRingOutline,
      },
    }
  },
}
</script>
